export default function translate(text) {
  return text;
}
